import { Link } from 'react-router-dom';

export default function FeaturedVehicles() {
  const vehicles = [
    {
      year: 2016,
      make: 'Honda',
      model: 'Civic',
      price: 8995,
      mileage: '98,500',
      image: 'https://public.readdy.ai/ai/img_res/931669c8348a33d94f26adb1b15e9f54.jpg',
      features: ['Automatic', 'FWD', 'Great MPG']
    },
    {
      year: 2015,
      make: 'Toyota',
      model: 'Corolla',
      price: 7995,
      mileage: '112,000',
      image: 'https://readdy.ai/api/search-image?query=White%202015%20Toyota%20Corolla%20sedan%20in%20pristine%20condition%20parked%20at%20modern%20dealership%20with%20clean%20simple%20background%20soft%20natural%20daylight%20three%20quarter%20front%20angle%20professional%20automotive%20photography%20highlighting%20dependability&width=800&height=600&seq=under10k-corolla&orientation=landscape',
      features: ['Automatic', 'FWD', 'Reliable']
    },
    {
      year: 2015,
      make: 'Ford',
      model: 'Escape',
      price: 9495,
      mileage: '105,000',
      image: 'https://readdy.ai/api/search-image?query=Dark%20blue%202015%20Ford%20Escape%20SUV%20displayed%20at%20professional%20dealership%20lot%20with%20minimal%20clean%20background%20natural%20lighting%20three%20quarter%20front%20view%20automotive%20photography%20style%20showing%20versatility%20and%20space&width=800&height=600&seq=under10k-escape&orientation=landscape',
      features: ['Automatic', 'AWD', 'Spacious']
    },
    {
      year: 2014,
      make: 'Mazda',
      model: 'Mazda3',
      price: 7495,
      mileage: '118,000',
      image: 'https://readdy.ai/api/search-image?query=Red%202014%20Mazda3%20hatchback%20parked%20in%20clean%20dealership%20environment%20with%20simple%20neutral%20background%20bright%20daylight%20three%20quarter%20front%20angle%20professional%20automotive%20photography%20emphasizing%20sporty%20design&width=800&height=600&seq=under10k-mazda3&orientation=landscape',
      features: ['Manual', 'FWD', 'Fun to Drive']
    },
    {
      year: 2013,
      make: 'Subaru',
      model: 'Outback',
      price: 9995,
      mileage: '135,000',
      image: 'https://readdy.ai/api/search-image?query=Green%202013%20Subaru%20Outback%20wagon%20at%20professional%20dealership%20with%20clean%20minimal%20background%20natural%20lighting%20three%20quarter%20front%20view%20automotive%20photography%20style%20highlighting%20adventure%20capability&width=800&height=600&seq=under10k-outback&orientation=landscape',
      features: ['Automatic', 'AWD', 'Adventure Ready']
    },
    {
      year: 2016,
      make: 'Hyundai',
      model: 'Elantra',
      price: 8495,
      mileage: '95,000',
      image: 'https://readdy.ai/api/search-image?query=Gray%202016%20Hyundai%20Elantra%20sedan%20displayed%20at%20modern%20dealership%20with%20simple%20clean%20background%20soft%20natural%20daylight%20three%20quarter%20front%20angle%20professional%20automotive%20photography%20showing%20modern%20styling&width=800&height=600&seq=under10k-elantra&orientation=landscape',
      features: ['Automatic', 'FWD', 'Warranty']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#1C2B1E] mb-4">
            Sample Vehicles Under $10K
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Quality inspected vehicles that fit your budget. Inventory changes daily — check our live inventory for current availability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {vehicles.map((vehicle, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-[#E8B84B] text-[#1C2B1E] px-4 py-2 rounded-lg font-bold text-lg shadow-lg">
                  ${vehicle.price.toLocaleString()}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#1C2B1E] mb-2">
                  {vehicle.year} {vehicle.make} {vehicle.model}
                </h3>
                
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-speed-line mr-2"></i>
                  <span>{vehicle.mileage} miles</span>
                </div>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {vehicle.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
                
                <Link
                  to="/inventory?priceMax=10000"
                  className="block w-full bg-[#1C2B1E] text-white text-center py-3 rounded-lg font-semibold hover:bg-[#2A3F2E] transition-colors whitespace-nowrap"
                >
                  Check Availability
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/inventory?priceMax=10000"
            className="inline-block bg-[#E8B84B] text-[#1C2B1E] px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#d4a43d] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            View All Under $10K Vehicles
          </Link>
        </div>
      </div>
    </section>
  );
}